export default "__VITE_ASSET__BsEGxUZU__"